import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
   return (
      <div className="fix-wrapper">
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-md-12">
                  <div className="form-input-content text-center error-page">
                     <h1 className="error-text font-weight-bold">404</h1>
                     <h4>
                        <i className="fa fa-exclamation-triangle text-warning" />{" "}
                        Halaman tidak ditemukan
                     </h4>
                     <p>
                        Silahkan periksa kembali tujuan Anda!
                     </p>
                     <div>
                        <Link className="btn btn-primary" to="/beranda">
                           Beranda
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error404;
